import { TableHeaderCell } from '@components/Table/TableHeaderCell';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { TableLinearLoading } from '@components/Table/TableLinearLoading';
import { TableNoResult } from '@components/Table/TableNoResult';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { IClienteSaldo } from '@model/ClienteSaldo';
import { useThemeColor } from '@themes/Colors';
import React from 'react';

export type SaldoTableProps = {
    data: IData<IClienteSaldo>
    isLoading: boolean
}

export function SaldoTable ({ data, isLoading }: SaldoTableProps) {
    const formatter = useFormatter();
    const themeColor = useThemeColor();

    const getValorColor = React.useCallback((valor: number) => {
        return valor >= 0 ? themeColor.status.verde : themeColor.status.vermelho;
    }, [themeColor.status.verde, themeColor.status.vermelho]);

    return (
        <React.Fragment>
            <TableLinearLoading isLoading={isLoading} />
            
            <TableNoResult itemCount={data.itemsCount}>
                <TableHead>
                    <TableRow>
                        <TableHeaderCell>ID</TableHeaderCell>
                        <TableHeaderCell>Descrição</TableHeaderCell>
                        <TableHeaderCell>Empresa</TableHeaderCell>
                        <TableHeaderCell>Data/Hora</TableHeaderCell>
                        <TableHeaderCell>Fatura</TableHeaderCell>
                        <TableHeaderCell>Operador</TableHeaderCell>
                        <TableHeaderCell>Valor</TableHeaderCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                {
                    data.items.map((clienteSaldo, index) => {
                        return (
                            <TableRow>
                                <TableKeyCell>{clienteSaldo.clienteSaldoId}</TableKeyCell>
                                <TableCell>{clienteSaldo.descricao}</TableCell>
                                <TableCell>{clienteSaldo.empresaNome}</TableCell>
                                <TableCell>{formatter.toDate(clienteSaldo.dataHora)}</TableCell>
                                <TableCell>{clienteSaldo.faturaId}</TableCell>
                                <TableCell>{clienteSaldo.usuarioNome}</TableCell>
                                <TableCell className={getValorColor(clienteSaldo.valor)}>{formatter.toFloat(clienteSaldo.valor)}</TableCell>
                            </TableRow>
                        )
                    })
                }
                </TableBody>
            </TableNoResult>
        </React.Fragment>
    )
}